import { Navigate, useLocation } from "react-router-dom";
import { usePageAccess } from "@/hooks/usePageAccess";

/**
 * Seitenschutz im Admin. Welche Seite eine Adresse ist, steht in der zentralen Liste
 * (src/config/adminNav.ts, Feld routes). Es gilt dieselbe Regel wie in der Leiste:
 * eigene page_access-Zeile der Seite, sonst die der Gruppe. Nicht registrierte Adressen
 * sind gesperrt (fail closed) — neue Routen also immer in adminNav.ts eintragen.
 */
export function RouteGuard({ children }: { children: React.ReactNode }) {
  const { canViewPath, loading } = usePageAccess();
  const { pathname } = useLocation();

  if (loading) return null;
  if (!canViewPath(pathname)) return <Navigate to="/admin" replace />;

  return <>{children}</>;
}
